<script>
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";
  import { getCollapseClass } from "../../Common/tools";
  import {M} from "../../external";

  export let data,
    isCollapsable = false,
    isCollapsed = false;

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }
</script>

<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}>
  <h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.COUPON_CODE}</h4>
</div>
{#if !isCollapsed}
  <div class="section">
    <div class="info">
      <span>Text</span>
    </div>
    <div class="right-side">
      <input bind:value={data.code} type="text" class="transition-border" />
    </div>
    <div class="popup-input-wrapper input-slider-wrapper mt-5">
      <h5 class="inline">{M.ALIGNMENT}</h5>
      <select bind:value={data.style.position}>
        <option value="left">{M.LEFT}</option>
        <option value="center">{M.CENTER}</option>
        <option value="right">{M.RIGHT}</option>
      </select>
    </div>
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.style.color} label={M.TEXT_COLOR} alpha="no" />
    </div>

    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.style.couponBackgroundColor} label={M.BACKGROUND_COLOR} alpha="no" />
    </div>
  </div>
{/if}
<BlockGlobal bind:data isCollapsable={true} isCollapsed={true} />
